// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__1U5Bo","title":"card_title__1sMTU","inActive":"card_inActive__3kOgM"};